import React, {useState, useEffect, useRef} from "react";
import {Button, Input, message, Modal} from "antd";
import {useStore} from "@vigo/hooks";

export const DeactivateWalletButton = ({courier, reloadCourier, refreshWallet}) => {
    const stores = useStore();
    const [isDeactivateModalVisible, setIsDeactivateModalVisible] = useState(false);
    const [deactivateReason, setDeactivateReason] = useState("");
    const [loading, setLoading] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const handleDeactivateWallet = async () => {
        setLoading(true);
        try {
            const result = await stores.courierStore.deactivateCourierWallet(courier._id, {reason: deactivateReason});
            if (isMountedRef.current) {
                if (result) {
                    message.success("Cüzdan başarıyla deaktive edildi.");
                    await reloadCourier(true);
                    refreshWallet();
                } else {
                    message.error("Cüzdan deaktive edilirken bir hata oluştu.");
                }
                setIsDeactivateModalVisible(false);
            }
        } catch (error) {
            if (isMountedRef.current) {
                message.error("Cüzdan deaktive edilirken bir hata oluştu.");
            }
        } finally {
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    };

    if (!courier.isWalletActive) return null;

    return (
        <React.Fragment>
            <Button
                type="danger"
                onClick={() => setIsDeactivateModalVisible(true)}
            >
                Cüzdanı Deaktive Et
            </Button>
            <Modal
                title="Cüzdanı Deaktive Et"
                visible={isDeactivateModalVisible}
                onOk={handleDeactivateWallet}
                onCancel={() => setIsDeactivateModalVisible(false)}
                confirmLoading={loading}
                okText="Deaktive Et"
                cancelText="İptal"
            >
                <Input.TextArea
                    rows={4}
                    value={deactivateReason}
                    onChange={e => setDeactivateReason(e.target.value)}
                    placeholder="Deaktive etme nedenini giriniz"
                />
            </Modal>
        </React.Fragment>
    );
}; 